import { qs } from "@fluorescent/dom";
import { section } from "@/glow";
import { featuredVideoHandler } from "@/lib/featured-video";
import { animateStandard, shouldAnimate } from "@/lib/animation";
import autoPlay from "../lib/autoPlay";
import ProductItem from "@/lib/product-item";

const selectors = {
  video: ".featured-collection-with-media__video",
};

section("featured-collection-with-media", {
  onLoad() {
    this.productItem = ProductItem(this.container);

    const video = qs(selectors.video, this.container);

    if (video) {
      this.videoHandler = featuredVideoHandler(this.container);
      autoPlay(video);
    }

    if (shouldAnimate(this.container)) {
      this.animateFeaturedCollectionWithMedia = animateStandard(this.container);
    }
  },

  onUnload() {
    this.productItem && this.productItem.unload();
    this.videoHandler && this.videoHandler();
    this.animateFeaturedCollectionWithMedia?.destroy();
  },
});
